import React from "react";
import { Modal, Typography, Button } from "antd";
import { useAuth } from "../../msalAuth/AuthProvider";
import { acquireLock, releaseLock } from "../../configure/concurrencyLock";
import { logInfo } from "../../configure/utils";
import { ClockCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const SessionExpiredModal = () => {
  const { loginNoPrompt } = useAuth();

  const handleLoginNoPrompt = () => {
    const gotLock = acquireLock("SANDEE_LOGIN_LOCK");
    if (!gotLock) {
      logInfo("Another tab is already logging in. Skipping in this tab.");
      return;
    }
    try {
      loginNoPrompt();
      setTimeout(() => releaseLock("SANDEE_LOGIN_LOCK"), 30000);
    } catch (err) {
      releaseLock("SANDEE_LOGIN_LOCK");
    }
  };

  return (
    <Modal open={true} footer={null} closable={false} maskClosable={false}>
      <div style={{ textAlign: "center", padding: "10px 40px" }}>
        <div
          style={{
            background: "#e6f4ff",
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px",
          }}
        >
          <ClockCircleOutlined
            style={{
              fontSize: "32px",
              color: "#1677ff",
            }}
          />
        </div>

        <Title level={4} style={{ marginBottom: "16px" }}>
          Session Expired
        </Title>
        <Text style={{ display: "block", marginBottom: "32px" }}>Your session has timed out due to inactivity. Please log in again.</Text>

        <Button
          onClick={handleLoginNoPrompt}
          type="primary"
          size="large"
          style={{
            height: "44px",
            padding: "0 32px",
            fontSize: "17px",
            fontWeight: 500,
          }}
        >
          Log in
        </Button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
